import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpUtils } from '../../shared/http-utils';
import { URL_BASE } from '../../core/constants';
import { Carrier } from './carrier.model';
import { Subcontractor } from './subcontractor.model';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { SearchObjectResult } from '../../shared/search-object-result.model';
import { NameSearchCriteria } from './name-search-criteria.model';

@Injectable()
export class SubcontractorService {

  constructor(private http: HttpClient) {
  }

  public search(
    page: number, size: number, criteria: NameSearchCriteria, selfCarrierMode: boolean, carriedId: string
  ): Observable<SearchObjectResult<Subcontractor>> {
    for (const key of Object.keys(criteria)) {
      if (!criteria[key]) {
        delete criteria[key];
      }
    }

    const headers = HttpUtils.createHeaders();
    const params  = {
      page: String(page),
      size: String(size),
      ...criteria
    };

    const url = selfCarrierMode ? `${URL_BASE}/api/subcontractors/for/carrier/self/search` : `${URL_BASE}/api/subcontractors/for/carrier/${carriedId}/search`;
    return this.http.get(url, { headers, params })
      .pipe(
        map(result => SearchObjectResult.fromDto(result, Subcontractor.fromDto))
      );
  }

  public getSelfCarrierSubcontractors(): Observable<Subcontractor[]> {
    const headers = HttpUtils.createHeaders();
    const url     = `${URL_BASE}/api/subcontractors/for/carrier/self`;

    return this.http.get(url, { headers })
      .pipe(
        map((result: any[]) => result.map(e => Subcontractor.fromDto(e)))
      );
  }

  public getCarrierSubcontractors(carrierId: string): Observable<Subcontractor[]> {
    const headers = HttpUtils.createHeaders();
    const url     = `${URL_BASE}/api/subcontractors/for/carrier/${carrierId}`;

    return this.http.get(url, { headers })
      .pipe(
        map((result: any[]) => result.map(e => Subcontractor.fromDto(e)))
      );
  }

  public getById(carrierId: string, subcontractorId: string): Observable<Subcontractor> {
    const headers = HttpUtils.createHeaders();
    const url     = `${URL_BASE}/api/subcontractors/${subcontractorId}`;

    return this.http.get(url, { headers })
      .pipe(
        map(s => Subcontractor.fromDto(s))
      );
  }

  public createForSelfCarrier(subcontractor: Subcontractor): Observable<Subcontractor> {
    const headers = HttpUtils.createHeaders();
    const url     = `${URL_BASE}/api/subcontractors/for/carrier/self`;

    return this.http.post(url, Subcontractor.toDto(subcontractor), { headers }).pipe(
      map(s => Subcontractor.fromDto(s))
    );
  }

  public createForCarrier(subcontractor: Subcontractor, carrier: Carrier): Observable<Subcontractor> {
    const headers = HttpUtils.createHeaders();
    const url     = `${URL_BASE}/api/subcontractors/for/carrier/${carrier.id}`;

    return this.http.post(url, Subcontractor.toDto(subcontractor), { headers })
      .pipe(
        map(s => Subcontractor.fromDto(s))
      );
  }

  public update(subcontractor: Subcontractor): Observable<Subcontractor> {
    const headers = HttpUtils.createHeaders();
    const url     = `${URL_BASE}/api/subcontractors/${subcontractor.id}`;

    return this.http.put(url, Subcontractor.toDto(subcontractor), { headers })
      .pipe(
        map(s => Subcontractor.fromDto(s))
      );
  }

  public remove(subcontractor: Subcontractor): Observable<void> {
    const headers = HttpUtils.createHeaders();
    const url     = `${URL_BASE}/api/subcontractors/${subcontractor.id}`;

    return this.http.delete<void>(url, { headers });
  }

}
